import React from "react"
import { Outlet } from "react-router-dom"
import { Box, Flex, Image, Link, Text } from "@chakra-ui/react";
import { PhoneIcon } from '@chakra-ui/icons'
import ParistokierratysImage from "src/assets/images/Paristokierratys_logo_punainen.png"
import SerkierratysImage from "src/assets/images/SER_tunnus_vari.png"
import FetchLogo from "src/assets/images/fetch-logo.svg"
import CartButton from "src/components/CartDrawer/components/CartButton";
import CartFooter from "src/components/CartFooter";
import { useCart } from "src/services/api/queries/queries";

const WasteCollectionHeader = () => {
    return (
        <Box 
            display="grid"
            gridTemplateColumns="repeat(3, 1fr)"
            height={{ sm: '120px', md: '160px' }}
            boxShadow='md'
            px='42px'
        >
            <Box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center">
                <Image 
                    src={ParistokierratysImage} 
                    alt="Paristokierrätys logo" 
                />
                <Link 
                    href="https://www.paristokierratys.fi/"
                    textDecoration="underline"
                    fontWeight="bold"
                >
                    <PhoneIcon marginRight="10px" />
                    030 6363 733
                </Link>
            </Box>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <Image 
                    src={SerkierratysImage} 
                    alt="Ser-kierrätys logo"
                    maxHeight="85.44px"
                />
                <Link 
                    href="https://www.serkierratys.fi/"
                    textDecoration="underline"
                    fontWeight="bold"
                >
                    <PhoneIcon marginRight="10px" />
                    020 703 2520
                </Link>
            </Box>
            <Box display="flex" flexDirection="column" alignItems="flex-end" justifyContent="center">
                <CartButton />
            </Box>
        </Box>
    );
};

const WasteCollectionFooter = () => {
    return (
        <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            paddingTop="64px"
            paddingBottom="80px"
            paddingX="42px"
        >
            <Flex direction="column">
                <Link href="https://www.paristokierratys.fi/kuljetuslaatikon-tilausehdot/">
                    Kuljetuslaatikon tilausehdot
                </Link>
                <Link href="https://www.paristokierratys.fi/wp-content/uploads/2022/03/Recser-Kerayspisteet-Tietosuojalauseke-2022.pdf">
                    Tietosuojalauseke
                </Link>
            </Flex>
            <Flex direction="column">
                <Text>Created by</Text>
                <Image 
                    src={FetchLogo}
                    alt="Fetch my stuff logo"
                    maxWidth="120px"
                />
            </Flex>
        </Box>
    );
};

export const WasteCollectionLayout = () => {
    const { data: cartItems } = useCart();
    return (
        <div>
            <WasteCollectionHeader/>
            <Outlet />
            <WasteCollectionFooter/>
            {cartItems?.items_count > 0 && <CartFooter />}
        </div>
    );
};